// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-container[data-v-6dae464e]{width:100%}.clear[data-v-6dae464e]{color:#dbdbdb;cursor:pointer;position:absolute;right:.625rem;top:.625rem;transition:all .3s ease-in-out}.clear[data-v-6dae464e]:hover{color:#b5b5b5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
